export const JWT_NS = 'cigna';
